
 export let mostrarRecorridoPausaServicio : string = "MOSTRAR_RECORRIDO_PAUSA_SERVICIO" // Si es 1 muestra las pausas en el recorrido del servicio en el reporte empresarial
 export let mostrarPolilyneTracking : string = "MOSTRAR_POLYLINE_TRACKING" // Si es 1 se visualiza  la ruta en base al tracking
 export let editarCajaOrigen : string = "EDITAR_CAJA_ORIGEN" // Editar caja origen
 export let ocultarSedesDestinos : string = "OCULTAR_SEDES_DESTINOS" 
 export let tiendacliente : number = 261 
 export let inmediatoReserva : string = "INMEDIATO_RESERVA"
 export let formatoCorreo:any=/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z-ñ\-0-9]+\.)+[a-zA-Z-ñ]{2,}))$/
 export let activaValidacionPrecupuestoPorEmpresa:string="ACTIVA_VALIDACION_PRESUPUESTO_NIVEL_CENTROCOSTO_OR_CLIENTE"



 










